'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var formField = require('./form-field-8601b6d9.js');
require('./messages-f8f39369.js');
var hqoSelectWrapper = require('./hqo-select-wrapper-6a70df14.js');

var useSelectedOption = function (_a) {
    var options = _a.options, value = _a.value;
    var selectedOption = React.useMemo(function () { return (value ? options.find(function (option) { return option.value === value; }) : null); }, [options, value]);
    return selectedOption || null;
};

var useControls = function (_a) {
    var value = _a.value, options = _a.options, onSelect = _a.onSelect;
    var handleClear = React.useCallback(function () {
        onSelect({ value: null });
    }, [onSelect]);
    var selectedOption = useSelectedOption({ options: options, value: value });
    return {
        selectedLabel: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label,
        handleClear: handleClear,
    };
};

var HqOSelect = function (_a) {
    var options = _a.options, value = _a.value, onSelect = _a.onSelect, required = _a.required, disabled = _a.disabled, readOnly = _a.readOnly, _b = _a.dataTestId, dataTestId = _b === void 0 ? 'hqo-select' : _b, restProps = tslib_es6.__rest(_a, ["options", "value", "onSelect", "required", "disabled", "readOnly", "dataTestId"]);
    var _c = useControls({ options: options, value: value, onSelect: onSelect }), selectedLabel = _c.selectedLabel, handleClear = _c.handleClear;
    return (React__default.createElement(formField.FormField, tslib_es6.__assign({}, restProps, { readOnly: readOnly, required: required, disabled: disabled, value: selectedLabel, dataTestId: dataTestId, customComponent: readOnly ? null : (React__default.createElement(hqoSelectWrapper.HqOSelectWrapper, tslib_es6.__assign({ options: options, selectedLabel: selectedLabel, disabled: disabled, required: required, value: value, onSelect: onSelect, handleClear: handleClear }, restProps))) })));
};

exports.HqOSelect = HqOSelect;
